import React, { useRef } from 'react';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../../../Grid';
import GridItem from '../../../GridItem';

import Title from './components/Title';
import Features from './components/Features';
import Description from './components/Description';
import Contacts from './components/Contacts';

import { useCardContext } from '../../index';

import styles, { mainCls, mapCls } from './style';

const useStyles = createStyle(styles);

export default function Details({
  saved,
  depthInfos,
  title,
  features,
  isAuction,
  isProjectProfile,
  projectData,
  description,
  publisher,
  visible,
  actions,
  showMortgage,
  showMqPrice,
  uri,
  vWidth,
  iosLth12,
  isHoliday,
}) {
  const { maplist } = useCardContext();

  const cls = useStyles();
  const details = useRef(null);  

  return (
    <div ref={details} className={`${cls[mainCls]} is-rel`}>
      <Grid
        className={cls[`${mainCls}__cont`]}
        direction="column"
      >
        <Title
          title={title}
          depthInfos={depthInfos}
          goToPDP={actions.goToPDP}
          uri={uri}
        />
        <GridItem>
          <Grid
            className={cls[`${maplist ? mapCls : mainCls}__infos`]}
            justify="space-evenly"
            direction="column"
          >
            <Features
              isAuction={isAuction}
              features={features}
              isProjectProfile={isProjectProfile}
              projectData={projectData}
              showMortgage={showMortgage}
              showMqPrice={showMqPrice}
              isHoliday={isHoliday}
              iosLth12={iosLth12}     
            /> 
            {!maplist && (
              <Description
                depthInfos={depthInfos}
                details={details}
                description={description}
                vWidth={vWidth}
              />
            )}
          </Grid>
        </GridItem>
        <Contacts
          publisher={publisher}
          saved={saved}
          visible={visible}
          actions={actions}
        />
      </Grid>
    </div>
  );
}